const styles = theme => ({
  container: {
    margin: '10px 0px',
    display: 'flex',
    alignItems: 'center',
  },
  breadcrumbs: {
    fontSize: '12px',
    lineHeight: '2px',
    '& li': {
      padding: '0',
      border: '0',
      '& > svg': {
        fontSize: '24px',
        color: '#CED1D6',
      },
    },
    '& a, & button': {
      color: '#0088FF',
      textDecoration: 'none',
      '& svg': {
        fontSize: '18px',
        marginRight: '6px',
      },
    },
    '& > .MuiBreadcrumbs-ol > .MuiBreadcrumbs-separator': {
      margin: '0px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
      lineHeight: '2px',
    },
  },
  activelink: {
    color: theme.palette.primary.darkGrey,
    textDecoration: 'none',
  },
  btn: {
    background: 'none',
    textTransform: 'none',
    fontSize: '12px',
    lineHeight: '2px',
    color: theme.palette.primary.adgmGreen,
    margin: 0,
    paddingLeft: 0,
    paddingRight: 0,
    fontWeight: 'normal',
    '&:hover': {
      background: 'none',
    },
    '&:focus': {
      background: 'none',
    },
    '&:focus-visible': {
      border: '2px solid #000',
      borderRadius: '0px',
    },
  },
});

export default styles;
